import Box                                  from '@/components/box/Box';
import { Center }                           from '@chakra-ui/react';
import CropperModal                         from '@/components/modal/CropperModal';
import PersonalInformationForm              from '@/pages/PersonalInformation/forms/PersonalInformationForm';
import ProfilePictureContainer              from '@/pages/PersonalInformation/components/ProfilePictureContainer';
import ProfilePictureModal                  from '@/pages/PersonalInformation/modals/ProfilePictureModal';
import React                                from 'react';
import { Spinner }                          from '@chakra-ui/react';
import UserMediaProfilePictureModel         from '@/models/services/fondations/UserMediaProfilePictureModel';
import authStore                            from '@/stores/authStore';
import { useTranslation }                   from 'react-i18next';
import { toaster }                          from '@/components/ui/toaster';

const PersonalInformationBox = () => {
	
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = React.useState(false);
	const [profilePictureModalIsOpen, setProfilePictureModalIsOpen] = React.useState(false);
	const [cropperModalIsOpen, setCropperModalIsOpen] = React.useState(false);
	const [newProfilePicture, setNewProfilePicture] = React.useState<File | undefined>();
	const [imageSource, setImageSource] = React.useState<string>('');
	const currentUser = authStore.currentUser;

	React.useEffect(() => {
		if (newProfilePicture) {
			const newImageSource = URL.createObjectURL(newProfilePicture);
			setImageSource(newImageSource);
		}
	}, [newProfilePicture]);

	const handleCropperSubmit = async (file: File) => {
		const newProfilePicture = await new UserMediaProfilePictureModel().upload(file, { type: file.type || '' }) as UserMediaProfilePictureModel;
		await currentUser.patch({
			userMediaProfilePicture: newProfilePicture.attributes["@id"]
		});
	}
	
	return (
		<Box>
			<ProfilePictureModal 
				isOpen={profilePictureModalIsOpen} 
				setIsOpen={setProfilePictureModalIsOpen}
				setIsLoading={setIsLoading}
			/>
			<CropperModal
				imageSource={imageSource} 
				imageType={newProfilePicture?.type || ''} 
				isOpen={cropperModalIsOpen} 
				setIsOpen={setCropperModalIsOpen} 
				setIsLoading={setIsLoading}
				onSubmit={handleCropperSubmit}
				onSuccess={() => {
					toaster.create({
						title: t('pages.personalInformation.personalInformationBox.modals.cropper.messages.success'),
						type: 'success'
					});
				}}
				onError={() => {
					toaster.create({
						title: t('pages.personalInformation.personalInformationBox.modals.cropper.messages.errors.error'),
						type: 'error'
					});
				}}
			/>
			{
				isLoading ?
				<Center height="100%" >
					<Spinner borderWidth="4px" size="xl" />
				</Center>
				:
				<>
					<ProfilePictureContainer 
						setProfilePictureModalIsOpen={setProfilePictureModalIsOpen} 
						setCropperModalIsOpen={setCropperModalIsOpen}
						setNewProfilePicture={setNewProfilePicture}
						setIsLoading={setIsLoading}
					/>

					<PersonalInformationForm />
				</>
			}
			
		</Box>
	);
};

export default PersonalInformationBox;